module.exports = __webpack_public_path__ + "media/discover_desktop.e83fadfc.mp4";